
/*
  RANKENWERK – Workshop-Termine
  Dawn 2.4.0
  Zeitzone: Europe/Berlin
*/

(() => {
  'use strict';

  const MONTHS = {
    januar: 0,
    februar: 1,
    märz: 2,
    maerz: 2,
    april: 3,
    mai: 4,
    juni: 5,
    juli: 6,
    august: 7,
    september: 8,
    oktober: 9,
    november: 10,
    dezember: 11
  };

  const MONTH_SHORT = [
    'Jan', 'Feb', 'Mär', 'Apr',
    'Mai', 'Jun', 'Jul', 'Aug',
    'Sep', 'Okt', 'Nov', 'Dez'
  ];

  const WEEKDAYS = [
    'So', 'Mo', 'Di', 'Mi',
    'Do', 'Fr', 'Sa'
  ];

  // Aktuelles Datum und Uhrzeit in Deutschland
  function getBerlinNow() {
    const formatter = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Berlin',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23'
    });

    const parts = Object.fromEntries(
      formatter.formatToParts(new Date())
        .filter(part => part.type !== 'literal')
        .map(part => [part.type, Number(part.value)])
    );

    return (
      Date.UTC(
        parts.year,
        parts.month - 1,
        parts.day,
        parts.hour,
        parts.minute
      )
    );
  }

  // Deutsche Variantenbezeichnung auslesen
  function parseWorkshopDate(title) {
    
const dateParts = title.split('|').map(s => s.trim());

const dateMatch = dateParts
  .join(' ')
  .match(new RegExp(
    '(\\d{1,2})\\.\\s*' +
    '(Januar|Februar|März|Maerz|April|Mai|Juni|' +
    'Juli|August|September|Oktober|November|Dezember)' +
    '\\s+(\\d{4})',
    'i'
  ));


    if (!dateMatch) return null;

    const day = Number(dateMatch[1]);
    const month = MONTHS[dateMatch[2].toLowerCase()];
    const year = Number(dateMatch[3]);

const timeMatch = title.match(
  /([0-9]{1,2})(?:[:.]([0-9]{2}))?[ \t]*Uhr/i
);



    if (!timeMatch) return null;

    const hour = Number(timeMatch[1]);
    const minute = timeMatch[2]
      ? Number(timeMatch[2])
      : 0;

    if (
      month === undefined ||
      year < 2020 ||
      day < 1 || day > 31 ||
      hour > 23 ||
      minute > 59
    ) {
      return null;
    }

    const date = new Date(
      Date.UTC(year, month, day, hour, minute)
    );

    // Ungültige Datumsangaben ausschließen
    if (
      date.getUTCFullYear() !== year ||
      date.getUTCMonth() !== month ||
      date.getUTCDate() !== day
    ) {
      return null;
    }

    const weekday = WEEKDAYS[
      new Date(Date.UTC(year, month, day)).getUTCDay()
    ];

    return {
      day,
      month,
      year,
      weekday,
      monthLabel: MONTH_SHORT[month],
      timeLabel:
        `${hour}:${String(minute).padStart(2, '0')} Uhr`,
      sortValue:
        Date.UTC(year, month, day, hour, minute)
    };
  }

  // HTML-Element sicher erstellen
  function element(tag, className, content) {
    const node = document.createElement(tag);

    if (className) {
      node.className = className;
    }

    if (content !== undefined) {
      node.textContent = content;
    }

    return node;
  }

  // Einzelnen Termin darstellen
  function createDateLink(item, isNext) {
    const link = element(
      'a',
      'rw-workshop-date' +
        (isNext ? ' rw-workshop-date--next' : '')
    );

    link.href = item.url;

    const calendar = element(
      'span', 'rw-workshop-date__calendar'
    );

    calendar.append(
      element('span', '', item.weekday),
      element('strong', '', String(item.day)),
      element('span', '', item.monthLabel)
    );

    const information = element(
      'span', 'rw-workshop-date__information'
    );

    information.append(
      element(
        'span',
        'rw-workshop-date__time',
        item.timeLabel
      )
    );

    // Restplätze nur bei aktivierter Bestandsführung
    if (
      item.tracked &&
      item.quantity > 0 &&
      item.quantity <= 3
    ) {
      const label = item.quantity === 1
        ? 'Nur noch 1 Platz'
        : `Nur noch ${item.quantity} Plätze`;

      information.append(
        element(
          'span',
          'rw-workshop-date__remaining',
          label
        )
      );
    }

    const arrow = element(
      'span',
      'rw-workshop-date__arrow',
      '›'
    );
    arrow.setAttribute('aria-hidden', 'true');

    link.append(calendar, information, arrow);

    const dateLabel =
      `${item.weekday}, ${item.day}. ` +
      `${item.monthLabel} ${item.year}, ${item.timeLabel}`;

    link.setAttribute(
      'aria-label',
      `Workshop-Termin ${dateLabel} auswählen`
    );

    return link;
  }

  // Ohne freie Termine
  function createEmptyCard(productUrl, unknownDates) {
    const box = element(
      'div', 'rw-workshop-card__empty'
    );

    const heading = element(
      'span',
      'rw-workshop-card__empty-title',
      unknownDates
        ? 'Termine auf der Produktseite ansehen'
        : 'Aktuell keine freien Termine'
    );

    const description = element(
      'span',
      'rw-workshop-card__empty-text',
      unknownDates
        ? 'Weitere Informationen und Buchungsmöglichkeiten'
        : 'Neue Termine in Planung'
    );

    const link = element(
      'a',
      'rw-workshop-card__empty-link',
      'Mehr Details →'
    );

    link.href = productUrl;

    box.append(heading, description, link);

    return box;
  }

  // Eine Produktkarte aufbauen
  function renderWorkshop(card) {
    const output = card.querySelector(
      '.rw-workshop-card__output'
    );

    if (!output) return;

    const productUrl = card.dataset.productUrl;
    const variantNodes = Array.from(
      card.querySelectorAll('[data-rw-variant]')
    );

    const now = getBerlinNow();
    let unknownDates = false;

    const dates = [];

    variantNodes.forEach(node => {
      const parsed = parseWorkshopDate(
        node.dataset.title || ''
      );

      if (!parsed) {
        unknownDates = true;
        return;
      }

      const available =
        node.dataset.available === 'true';

      const tracked =
        node.dataset.tracked === 'true';

      const quantity = Number(
        node.dataset.quantity || 0
      );

      const policy = node.dataset.policy;

      // Keine Überbuchung von ausverkauften Terminen
      const hasStock =
        !tracked || quantity > 0;

      const canBook = available && hasStock;

      if (!canBook) return;

      // Bereits begonnene Termine ausblenden
      if (parsed.sortValue <= now) return;

      const url = new URL(
        productUrl,
        window.location.origin
      );

      url.searchParams.set(
        'variant',
        node.dataset.id
      );

      dates.push({
        ...parsed,
        title: node.dataset.title,
        url: url.toString(),
        quantity,
        tracked,
        policy
      });
    });

    dates.sort((a, b) => a.sortValue - b.sortValue);

    const content = document.createDocumentFragment();

    if (dates.length === 0) {
      content.append(
        createEmptyCard(productUrl, unknownDates)
      );

      output.replaceChildren(content);
      return;
    }

    // Nächster freier Termin
    const heading = element(
      'div',
      'rw-workshop-card__heading',
      '▦ Nächster freier Termin'
    );

    content.append(heading);
    content.append(createDateLink(dates[0], true));

    // Weitere Termine als ausklappbare Liste
    if (dates.length > 1) {
      const details = element(
        'details', 'rw-workshop-card__more'
      );

      const count = dates.length - 1;

      const summary = element(
        'summary',
        '',
        `+ ${count} weitere${count === 1 ? 'r Termin' : ' Termine'}`
      );

      const list = element(
        'div',
        'rw-workshop-card__more-list'
      );

      dates.slice(1).forEach(item => {
        list.append(
          createDateLink(item, false)
        );
      });

      details.append(summary, list);
      content.append(details);
    }

    output.replaceChildren(content);
  }

  function initialize(root = document) {
    root.querySelectorAll(
      '[data-rw-workshop]'
    ).forEach(renderWorkshop);
  }

  // Normales Laden
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => initialize(),
      { once: true }
    );
  } else {
    initialize();
  }

  // Shopify Theme-Editor
  document.addEventListener(
    'shopify:section:load',
    event => initialize(event.target)
  );
})();

/*
  RANKENWERK – Automatische Ausrichtung
  der Workshop-Terminkacheln
  Berücksichtigt Produkttitel und Bewertungen
*/

(() => {
  'use strict';

  let scheduled = false;

  function alignWorkshopCards() {
    const grid = document.querySelector('#product-grid');
    if (!grid) return;

    const rows = new Map();
    const cards = grid.querySelectorAll('.rw-workshop-card');

    // Alte Ausrichtung zurücksetzen
    cards.forEach(card => {
      card.style.marginTop = '10px';
    });

    // Produktkarten nach sichtbarer Reihe gruppieren
    cards.forEach(card => {
      const item = card.closest('.grid__item');
      if (!item) return;

      const rowTop = Math.round(
        item.getBoundingClientRect().top
      );

      let rowKey = [...rows.keys()].find(
        key => Math.abs(key - rowTop) <= 4
      );

      if (rowKey === undefined) {
        rowKey = rowTop;
        rows.set(rowKey, []);
      }

      rows.get(rowKey).push(card);
    });

    // Alle Terminkacheln einer Reihe
    // am tiefsten Startpunkt ausrichten
    rows.forEach(rowCards => {
      const maxTop = Math.max(
        ...rowCards.map(card =>
          card.getBoundingClientRect().top
        )
      );

      rowCards.forEach(card => {
        const currentTop =
          card.getBoundingClientRect().top;

        const difference = Math.max(
          0,
          maxTop - currentTop
        );

        card.style.marginTop =
          `${10 + difference}px`;
      });
    });
  }

  function scheduleAlignment() {
    if (scheduled) return;

    scheduled = true;

    requestAnimationFrame(() => {
      scheduled = false;
      alignWorkshopCards();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      scheduleAlignment
    );
  } else {
    scheduleAlignment();
  }

  window.addEventListener(
    'load',
    scheduleAlignment
  );

  window.addEventListener(
    'resize',
    scheduleAlignment,
    { passive: true }
  );

  document.addEventListener(
    'shopify:section:load',
    scheduleAlignment
  );
})();
